import React, { createElement, Fragment } from "react";
import { Helmet } from "react-helmet";
import { Resources } from "ducks/Resources/index";

export default function ResourcesPage(props) {
  return (
    <Fragment>
      <Helmet>
        <title>{"Resources - Savant Power"}</title>
      </Helmet>
      {createElement(Resources, props)}
    </Fragment>
  );
}
